import { Row, Col } from 'reactstrap';

import { CustomButton } from '@shared/buttons';
import useTranslation from '@shared/hooks/useTranslation';
import {
  CloseIcon,
} from '@shared/icons';

import '../VerificationModalStyle.scss';

type IVerificationContent = {
  onToggle: () => void;
  type?: string;
};

const VerifiedContent = ({ onToggle, type }: IVerificationContent) => {
  const i18nVerification = useTranslation('verification.account.modal.verified');
  const closeTitle = useTranslation('verification.button.close');

  return (
    <div className="password-changed-content-container">
      <Row className="mb-3">
        <Col className="fp-close-button-style">
          <a aria-label="Close" role="button" href="#" onClick={onToggle}><CloseIcon /></a>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="s2 password-changed-modal-title mb-5">
            {type === 'email' ? i18nVerification.email.title : i18nVerification.mobile.title}
          </div>
          <div className="b1 mb-4">
            {type === 'email' ? i18nVerification.email.description : i18nVerification.mobile.description}
          </div>
          <CustomButton
            id="btn-send"
            color="primary"
            className="btn-lg go-to-login-btn"
            onClick={onToggle}
          >
            {closeTitle}
          </CustomButton>
        </Col>
      </Row>
    </div>
  );
};

export default VerifiedContent;
